// Sidebars
import defaultSidebarList from '@/components/Sidebars/SidebarExtraLista'
import defaultSidebarItem from '@/components/Sidebars/SidebarExtraItem'

// Funciones
const functions = {
	sensitive: (e) => {
		return e.charAt(0).toUpperCase() + e.slice(1)
	}
}

// Routes
const typeRoutes = {
	newRoute: {name: 'user', params: {id: 'new'}},
	editRoute: {name: 'user'}
}

// Conexiones
const connections = {
	typeUrl: 'users',
	constType: 'usuarios'
}

// Listas
const paginationList = {
	results: 9999,
	limit: 9999
}

const sidebarExtra = {
	list: defaultSidebarList,
	item: defaultSidebarItem
}

// Datos a mostrar en el listado
const dataShow = [
	{
		id: 'nombre',
		name: 'Nombre',
		order: 'asc',
		selected: false,
		classes: {
			list: 'xs12 sm12 md1 lg1 xl1',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		truncate: true,
		sensitive: functions.sensitive
	},
	{
		id: 'apellidos',
		name: 'Apellidos',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md1 lg1 xl1 ',
			card: 'xs12 sm12 md12 lg12 xl6 d-none'
		},
		selected: false
	},
	{
		id: 'email',
		name: 'Email',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md2 lg2 xl2',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		truncate: true,
		selected: false,
	},
	{
		id: 'lugar_nacimiento',
		name: 'Lugar nac.',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md2 lg2 xl2',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: false
	},
	{
		id: 'lugar_residencia',
		name: 'Lugar res.',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md1 lg1 xl1',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: false
	},
	{
		id: 'fecha_nacimiento',
		name: 'Fecha nac.',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md1 lg1 xl1',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: false,
		type: 'date'
	},
	{
		id: 'hora_nacimiento',
		name: 'Hora nac.',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md1 lg1 xl1',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: false
	},
	{
		id: 'sexo',
		name: 'Sexo',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md1 lg1 xl1',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: false
	},
	{
		id: 'fecha_inicio',
		name: 'Inicio suscripción',
		order: 'desc', 
		classes: {
			list: 'xs12 sm12 md1 lg1 xl1',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: true,
		type: 'date'
	},
	{
		id: 'fecha_fin',
		name: 'Fin suscripción',
		order: 'desc',
		classes: {
			list: 'xs12 sm12 md1 lg1 xl1',
			card: 'xs12 sm12 md12 lg12 xl6'
		},
		selected: false,
		type: 'date'
	}
]

// Datos formulario Item
const formData = {
	data: {
		nombre: '',
		apellidos: '',
		email: '',
		lugar_nacimiento: '',
		lugar_residencia: '',
		fecha_nacimiento: '',
		hora_nacimiento: '',
		sexo: '',
		fecha_inicio: '',
		fecha_fin: '',
	},
	clean() {
		this.data = {
			nombre: '',
			apellidos: '',
			email: '',
			lugar_nacimiento: '',
			lugar_residencia: '',
			fecha_nacimiento: '',
			hora_nacimiento: '',
			sexo: '',
			fecha_inicio: '',
			fecha_fin: '',
		}
	}
}

// Tabs para el Item
const tabsItem = [
	{
		id: 'general',
		name: 'General',
		active: true
	},
	{
		id: 'datosExtra',
		name: 'Datos extras',
		active: false
	},
	{
		id: 'pilares',
		name: 'Pilares',
		active: false,
		type: 'other'
	}
]

// Campos en el Item
const fields = [
	{
		name: 'nombre',
		tabID: 'general',
		titled: true, // Si sale en la cabecera de la CARD
		type: 'text',
		classes: 'xs12 sm12 md12 lg12 xl6 pb-3',
		label: 'Nombre',
		placeholder: 'Nombre',
		required: true,
		box: false,
		outline: false,
		persistentHint: false,
		rules: [
			v => !!v || 'Nombre es requerido',
		],
		sensitive: functions.sensitive,
		disabled: true
	},
	{
		name: 'apellidos',
		tabID: 'general',
		type: 'text',
		label: 'Apellidos',
		placeholder: 'Apellidos',
		sensitive: (e) => {
			return e
		},
		disabled: true
	},
	{
		name: 'email',
		tabID: 'general',
		type: 'text',
		classes: 'xs12 sm12 md12 lg12 xl12 pb-3',
		label: 'Email',
		placeholder: 'Email',
		disabled: true,
	},
	{
		name: 'fecha_inicio',
		tabID: 'general',
		type: 'birthDate',
		label: 'Inicio suscripción',
		placeholder: 'Inicio suscripción',
		disabled: true
	},
	{
		name: 'fecha_fin',
		tabID: 'general',
		type: 'birthDate',
		label: 'Fin suscripción',
		placeholder: 'Fin suscripción',
		disabled: true
	},
	{
		name: 'lugar_nacimiento',
		tabID: 'datosExtra',
		type: 'text',
		label: 'Lugar nacimiento',
		placeholder: 'Lugar nacimiento',
		disabled: true
	},
	{
		name: 'lugar_residencia',
		tabID: 'datosExtra',
		type: 'text',
		label: 'Lugar de Residencia',
		placeholder: 'Lugar de Residencia',
		disabled: true
	},
	{
		name: 'fecha_nacimiento',
		tabID: 'datosExtra',
		type: 'birthDate',
		label: 'Fecha nacimiento',
		placeholder: 'Fecha nacimiento',
		disabled: true
	},
	{
		name: 'hora_nacimiento',
		tabID: 'datosExtra',
		type: 'time',
		label: 'Hora de nacimiento',
		placeholder: 'Hora de nacimiento',
		disabled: true
	},
	{
		name: 'sexo',
		tabID: 'datosExtra',
		type: 'text',
		label: 'Género',
		placeholder: 'Género',
		disabled: true
	},
	{
		name: 'uuid',
		tabID: 'datosExtra',
		type: 'text',
		label: 'Dispositivo',
		placeholder: 'Dispositivo',
		disabled: true
	},
	{
		name: 'pilares',
		tabID: 'pilares',
		type: 'array',
		noResultText: `No hay pilares registrados`,
		hideActions: true,
		headers: [
			{
				text: 'Tipo', value: 'tipo', class: 'navbartext bodybackground--text subheading', sortable: false, rowClass: "body-2"
			},
			{
				text: 'Elemento', value: 'elemento_superior', class: 'navbartext bodybackground--text subheading', sortable: false, rowClass: "body-2"
			},
			{
				text: 'Animal', value: 'elemento_inferior', class: 'navbartext bodybackground--text subheading', sortable: false, rowClass: "body-2"
			},
			{
				text: 'Superior', value: 'superior', class: 'navbartext bodybackground--text subheading text-xs-center', sortable: false, rowClass: "text-xs-center body-2"
			},
			{
				text: 'Inferior', value: 'inferior', class: 'navbartext bodybackground--text subheading text-xs-center', sortable: false, rowClass: "text-xs-center body-2"
			},
			{
				text: 'Variable', value: 'variable', class: 'navbartext bodybackground--text subheading text-xs-center', sortable: false, rowClass: "text-xs-center body-2"
			}
		]
	},
]


export { typeRoutes, connections, formData, tabsItem, dataShow, paginationList, fields, sidebarExtra }
